// شناسه عمومی مستأجر در Client با همان قواعد سرور (BR-PLT-001، C-AGENT-152: TenantSlug.Validate). تست slug.test.ts
// فهرست رزرو را با src/Modules/Platform/Phoenix.Platform.Domain/Tenants/TenantSlug.cs برابر نگه می‌دارد.
import { z } from 'zod';

export const SLUG_MIN = 3;
export const SLUG_MAX = 30;
const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9]|-(?=[a-z0-9]))*$/;

export const RESERVED_SLUGS: ReadonlySet<string> = new Set([
  'admin',
  'administrator',
  'api',
  'app',
  'apps',
  'assets',
  'auth',
  'billing',
  'blog',
  'cdn',
  'console',
  'dashboard',
  'dev',
  'docs',
  'help',
  'id',
  'identity',
  'internal',
  'kiosk',
  'login',
  'logout',
  'mail',
  'media',
  'ops',
  'phoenix',
  'phoenixclinic',
  'platform',
  'portal',
  'root',
  'signup',
  'smtp',
  'sso',
  'staff',
  'staging',
  'static',
  'status',
  'support',
  'system',
  'test',
  'www',
  'ftp',
  'keycloak',
  'minio',
  'grafana',
  'metrics',
  'health',
  'jobs',
  'public',
  'register',
  'security',
  'ws',
  'www1',
  'www2',
  'localhost',
  'null',
  'undefined',
  'owner',
  'superuser',
  'ghoghnoos',
]);

export type SlugProblem = 'required' | 'length' | 'pattern' | 'reserved';

/** علت نامعتبر بودن (null = معتبر)؛ هم‌ارز TenantSlug.Validate سرور. */
export function validateSlug(value: string | null | undefined): SlugProblem | null {
  const trimmed = (value ?? '').trim();
  if (!trimmed) {
    return 'required';
  }
  if (trimmed.length < SLUG_MIN || trimmed.length > SLUG_MAX) {
    return 'length';
  }
  if (!SLUG_PATTERN.test(trimmed)) {
    return 'pattern';
  }
  return RESERVED_SLUGS.has(trimmed) ? 'reserved' : null;
}

/** قطعه Zod شناسه عمومی؛ پیام همان کلید خطای فیلد سرور (errors:validation.tenant_slug_*). */
export const zSlug = () =>
  z.string().superRefine((value, ctx) => {
    const problem = validateSlug(value);
    if (problem) {
      ctx.addIssue({ code: 'custom', message: `errors:validation.tenant_slug_${problem}` });
    }
  });
